import { render } from "./MultiviewPage.vue?vue&type=template&id=a4223bdc"
import script from "./MultiviewPage.vue?vue&type=script&lang=js"
export * from "./MultiviewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__